export * from './offersFeatureObserver';
